<template>
  <div v-if="isOpen" class="otb-test-drive-from-home-information-modal">
    <wb-modal
      mode="edit-mobile-fullscreen"
      @wbclose="handleModalClose"
      close-on-backdrop-click
      close-on-escape-key
      scroll-lock
    >
      <wb-modal-header />

      <wb-modal-content
        class="otb-test-drive-from-home-information-modal__content"
        :class="{
          'otb-test-drive-from-home-information-modal__content__desktop':
            !isSmallScreen,
        }"
      >
        <div
          class="otb-test-drive-from-home-information-modal__content__text__title"
        >
          <span class="wb-type-heading-s">{{
            $t('tdfh.modal.header.title')
          }}</span>
          <wb-tag variant="primary">{{ $t('tdfh.modal.header.badge') }}</wb-tag>
        </div>
        <p class="wb-type-copy-secondary wb-margin-bottom-xs">
          {{ $t('tdfh.modal.description.title') }}
        </p>
        <wb-accordion
          v-for="({ question, answer, footnote }, index) in detailsList"
          :key="index"
          prevent-mobile-flyout
          class="otb-test-drive-from-home-information-modal__content__list"
        >
          <wb-accordion-item
            :open="indexOfOpenAccordion === index"
            @click="handleAccordionOpen(index)"
          >
            <wb-accordion-toggle>{{ question }}</wb-accordion-toggle>
            <wb-accordion-section>
              <wb-accordion-content
                class="otb-test-drive-from-home-information-modal__content__accordion"
              >
                <p>{{ answer }}</p>
                <p
                  v-if="footnote"
                  class="otb-test-drive-from-home-information-modal__content__list__footnote wb-type-hint"
                >
                  {{ footnote }}
                </p>
              </wb-accordion-content>
            </wb-accordion-section>
          </wb-accordion-item>
        </wb-accordion>
      </wb-modal-content>

      <wb-modal-footer
        v-if="!isInfo"
        class="otb-test-drive-from-home-information-modal__footer"
        :class="{
          'otb-test-drive-from-home-information-modal__footer__desktop':
            !isSmallScreen,
        }"
      >
        <button
          type="button"
          class="wb-button wb-button--primary wb-button--large"
          @click="handleModalConfirmation"
        >
          {{ $t('tdfh.modal.cta') }}
        </button>
      </wb-modal-footer>
    </wb-modal>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

import { i18n } from '../../../services/translation.service';

import { useMediaQuery } from '../../../composables/media-query.composable';

export default defineComponent({
  i18n,
  name: 'otb-test-drive-from-home-information-modal',
  props: {
    isInfo: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { isSmallScreen } = useMediaQuery();

    // refs
    const indexOfOpenAccordion = ref(-1);
    const detailsList = ref([
      {
        question: i18n.t('tdfh.modal.description.question1'),
        answer: i18n.t('tdfh.modal.description.text1'),
      },
      {
        question: i18n.t('tdfh.modal.description.question2'),
        answer: i18n.t('tdfh.modal.description.text2'),
      },
      {
        question: i18n.t('tdfh.modal.description.question3'),
        answer: i18n.t('tdfh.modal.description.text3'),
        footnote: i18n.t('tdfh.modal.description.tooltip3'),
      },
      {
        question: i18n.t('tdfh.modal.description.question4'),
        answer: i18n.t('tdfh.modal.description.text4'),
      },
      {
        question: i18n.t('tdfh.modal.description.question5'),
        answer: i18n.t('tdfh.modal.description.text5'),
      },
      {
        question: i18n.t('tdfh.modal.description.question6'),
        answer: i18n.t('tdfh.modal.description.text6'),
      },
    ]);

    // handlers
    const handleModalClose = () => {
      clearOpenAccordion();
      emit('event:close');
    };
    const handleModalConfirmation = () => {
      clearOpenAccordion();
      emit('event:confirmation');
    };
    const handleAccordionOpen = (index: number) => {
      if (indexOfOpenAccordion.value === index) {
        indexOfOpenAccordion.value = -1;
        return;
      }

      indexOfOpenAccordion.value = index;
    };

    // methods
    const clearOpenAccordion = () => (indexOfOpenAccordion.value = -1);

    return {
      isSmallScreen,
      // refs
      indexOfOpenAccordion,
      detailsList,
      // handlers
      handleModalClose,
      handleModalConfirmation,
      handleAccordionOpen,
    };
  },
});
</script>
<style lang="scss" src="./test-drive-from-home-information-modal.scss"></style>
